import { $Formutil } from 'react-bootstrap-formutil';

export interface ContactInformationFormutil {
    email?: string;
    tel_code?: string;
    username?: string;
    verify_code?: string;
    phone?: string;
}

export interface ContactInformationProps {
    disabled?: boolean;
    // 存在emailOptions才展示Email
    emailOptions?: {
        // 是否是预览模式, 预览模式下仅展示邮箱， 且不允许修改邮箱
        isPreview?: boolean;
        placeholder?: string;
        defaultValue?: string;
        className?: string;
        show?: boolean;
    };
    // 存在phoneOptions才展示Phone
    phoneOptions?: {
        // 是否是预览模式, 预览模式下仅展示手机号， 且不允许修改手机号
        isPreview?: boolean;
        defaultTelCode?: string;
        defaultPhone?: string;
        className?: string;
        show?: boolean;
    };
    $formutil: $Formutil<ContactInformationFormutil>;
}
